import type { Perspective } from './perspective'

export interface FeedbackTopic {
  readonly id: string
  readonly title: string
  readonly description?: string
  readonly icon?: string
  readonly type: FeedbackTopicType
  readonly excerpt?: string
  readonly perspectives: ReadonlyArray<Perspective>
  readonly includeSelf: boolean
  /** Offered only to coaches. Not selectable as a dialog topic or an objective topic. */
  readonly coachOnly?: boolean
  readonly showBlindspots?: boolean
  readonly skillVisualization?: ReadonlyArray<SkillVisualization>
}

export enum FeedbackTopicType {
  Evaluation = 'evaluation',
  Journal = 'journal',
  Superpower = 'superpower',
  Pulse = 'pulse',
}

export const withoutCoachOnlyTopics = <T extends { coachOnly?: boolean }>(
  topics: readonly T[],
): T[] => topics.filter((topic) => !topic.coachOnly)

export enum SkillVisualization {
  MenonChart = 'menon_chart',
  MenonChartSplit = 'menon_chart_split',
  Histogram = 'histogram',
}
